<template>
  <div>
    <div>
      <el-button type="primary" plain @click="$emit('component-change', { name: 'list' })"
        >返回</el-button
      >
      <el-button type="success" @click="apply">下发商品配置</el-button>
      <el-button type="primary" @click="show = true">添加商品</el-button>
    </div>
    <div class="common-table">
      <el-table
        v-loading="loading"
        :data="iosChannelProductList.beanList"
        :row-key="(row) => row.id + row.updateTime"
        height="100%"
      >
        <el-table-column label="编号" align="center" type="index" />
        <el-table-column label="名称" align="center" prop="title" />
        <el-table-column label="icon" align="center" width="100">
          <template slot-scope="scope">
            <preview-picture :src="scope.row.icon" />
          </template>
        </el-table-column>
        <el-table-column label="价值金豆数量" width="120" align="center" prop="idouNum">
          <template slot-scope="scope">{{ scope.row.status | numberChip }}</template>
        </el-table-column>
        <el-table-column label="价格" align="center" prop="price" />
        <el-table-column label="折扣" align="center" prop="discount" width="80" />
        <el-table-column label="状态" align="center" width="80">
          <template slot-scope="scope">{{ scope.row.status | statusName }}</template>
        </el-table-column>
        <el-table-column label="最后更新时间" align="center" prop="updateTime" width="180" />
        <el-table-column label="备注" min-width="150" align="center" prop="remark" />
        <el-table-column label="操作" align="center" width="150">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="editFunc(scope.row)">编辑</el-button>
            <el-button type="danger" size="mini" @click="removeItem(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="common-el-pagination"
      background
      layout="prev,pager,next,jumper"
      :page-size="20"
      :pager-count="5"
      :total="iosChannelProductList.total"
      :current-page="currentPage"
      @current-change="getList(id, $event)"
    />
    <div v-if="show" class="common-popup-bg">
      <div class="common-popup">
        <h3>商品编辑</h3>
        <el-form :model="form">
          <table class="common-popup-table" style="width: 700px">
            <tr>
              <td class="required">名称：</td>
              <td colspan="3">
                <el-input placeholder="请输入" v-model="form.title" size="medium" />
              </td>
              <td class="required">状态：</td>
              <td>
                <el-select v-model="form.status" size="medium">
                  <el-option
                    v-for="item of statusOptions"
                    :key="item.label"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </td>
            </tr>
            <tr>
              <td class="required">价格：</td>
              <td>
                <el-input placeholder="请输入" type="number" v-model="form.price" size="medium" />
              </td>
              <td>折扣：</td>
              <td>
                <el-input
                  type="number"
                  v-model="form.discount"
                  size="medium"
                  placeholder="范围0~1"
                />
              </td>
              <td class="required">金豆数：</td>
              <td>
                <el-input placeholder="请输入" type="number" v-model="form.idouNum" size="medium" />
              </td>
            </tr>
            <tr>
              <td class="required">code：</td>
              <td>
                <el-input placeholder="请输入" v-model="form.productCode" size="medium" />
              </td>
              <td class="required">icon：</td>
              <td rowspan="2">
                <div class="common-uploadImg">
                  <input @change="fileChange" type="file" accept="image/*" />
                  <img v-if="form.icon" :src="form.icon" class="avatar" />
                  <i v-else class="el-icon-plus"></i>
                </div>
              </td>
            </tr>
            <tr>
              <td>权重：</td>
              <td>
                <el-input type="number" v-model="form.sortNo" size="medium" />
              </td>
            </tr>
            <tr>
              <td>备注：</td>
              <td colspan="5">
                <el-input v-model="form.remark" type="textarea" resize="none" />
              </td>
            </tr>
          </table>
        </el-form>
        <footer>
          <el-button size="small" @click="close">取消</el-button>
          <el-button size="small" @click="submit" type="primary">确定</el-button>
        </footer>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import previewPicture from 'components/previewPicture';

export default {
  components: {
    previewPicture,
  },
  props: {
    id: [String, Number],
  },
  data() {
    return {
      loading: false,
      show: false,
      currentPage: 1,
      statusOptions: [
        // 状态类型
        {
          label: '下架',
          value: 0,
        },
        {
          label: '上架',
          value: 1,
        },
      ],
      form: {
        id: null,
        title: null, // 商品名称
        channelId: null, // 内购配置渠道id
        price: null, // 价格
        productCode: '', // 商品code
        discount: null, // 折扣
        idouNum: null, // 价值金豆数
        status: null, // 状态
        icon: null, // 图标URL
        sortNo: null, // 排序号
        remark: '', // 备注
      },
      imgFile: null, // 选择上传的图片
    };
  },
  computed: {
    ...mapState('product', ['iosChannelProductList']),
  },
  watch: {
    id(newVal) {
      this.getList(newVal);
    },
  },
  created() {
    this.getList(this.id);
  },
  filters: {
    statusName(status) {
      switch (status) {
        case 0:
          status = '下架';
          break;
        case 1:
          status = '上架';
          break;
        default:
          break;
      }
      return status;
    },
  },
  methods: {
    ...mapActions('other', ['uploadImg']),
    ...mapActions('product', [
      'getIosChannelProductList',
      'addIosChannelProduct',
      'updateIosChannelProduct',
      'deleteIosChannelProduct',
      'applyIosChannel',
    ]),
    getList(id, page = 1) {
      this.form.channelId = id;
      this.loading = true;
      this.currentPage = page;
      this.getIosChannelProductList({
        id,
        page,
      }).then(() => {
        this.loading = false;
        if (!this.iosChannelProductList.length && page !== 1) {
          this.getList(id, page - 1);
        }
      });
    },
    removeItem(id) {
      this.loading = true;
      this.deleteIosChannelProduct(id).then(() => {
        this.$message.success('删除成功');
        this.getList(this.id);
      });
    },
    editFunc(info) {
      this.show = true;
      for (let key in this.form) {
        this.form[key] = info[key];
      }
    },
    close() {
      this.show = false;
      Object.assign(this.form, {
        id: null,
        title: null, // 商品名称
        price: null, // 价格
        discount: null, // 折扣
        idouNum: null, // 价值金豆数
        status: null, // 状态
        productCode: null, // 商品编码
        icon: null, // 图标URL
        sortNo: null, // 排序号
        remark: '', // 备注
      });
    },
    async submit() {
      if (this.form.title === null) {
        this.$message.error('请输入名称');
        return;
      } else if (this.form.price === null) {
        this.$message.error('请输入价格');
        return;
      } else if (
        this.form.discount !== null &&
        (this.form.discount > 1 || this.form.discount < 0)
      ) {
        this.$message.error('折扣范围0~1');
        return;
      } else if (this.form.idouNum === null) {
        this.$message.error('请输入金豆数');
        return;
      } else if (this.form.status === null) {
        this.$message.error('请选择状态');
        return;
      } else if (this.form.productCode === null) {
        this.$message.error('请输入code');
        return;
      } else if (this.form.icon === null) {
        this.$message.error('请选择icon');
        return;
      }

      if (this.imgFile) {
        let params = new FormData();
        params.append('file', this.imgFile);
        this.form.icon = await this.uploadImg(params).then((res) => {
          return `${res.data.imageUrl}`; //http://${res.data.file_ip}:${res.data.file_port}
        });
        this.imgFile = null;
      }
      let { id, ...params } = this.form;
      if (id) {
        this.updateIosChannelProduct(this.form).then(() => {
          this.$message.success('修改成功');
          this.close();
          this.getList(this.id, this.currentPage);
        });
      } else {
        this.addIosChannelProduct(params).then(() => {
          this.$message.success('新增成功');
          this.close();
          this.getList(this.id, this.currentPage);
        });
      }
    },
    fileChange(e) {
      if (e.target.files.length) {
        this.imgFile = e.target.files[0];
        let f = new Blob([this.imgFile]);
        this.form.icon = URL.createObjectURL(f);
      }
    },
    // 下发商品配置
    apply() {
      this.applyIosChannel(this.id).then(() => {
        this.$message.success('下发商品配置成功');
      });
    },
  },
};
</script>
